import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import interceptorSetup from './config/routeInterceptor';
import { i18n, loadLanguageAsync } from './localization';
import { setup as setupErrorHandling } from '@/config/errorHandling';
import { setupStatsig } from '@/tracking/statsig';
import { VueHeadMixin, createHead } from '@unhead/vue';
import { Market } from '@shared/config/market/market.models';
import { vMaska } from 'maska/vue';
// eslint-disable-next-line import/no-named-as-default
import VueShowdown from 'vue-showdown';
import VueTippy from 'vue-tippy';
import { vuetify } from '@/vuetify';
import { setupSentry } from '@/config/logging';
import { suppressDirective } from './directives/suppress';
import { capitalizeDirective } from './directives/capitalize';

declare global {
    interface Window {
        dataLayer?: object[];
        dataLayerDebug?: object[];
        clarity?: (cmd: string, event: string) => void;
        clarityEvents?: string[];
        clarityDebugEvents?: string[];
        statsig?: object[];
        statsigDebug?: object[];
        shouldReload: boolean;
        Osano: any;
    }
}

export const app = createApp(App);
const head = createHead();

app.use(store);
app.use(router);
app.use(i18n);
app.use(head);
app.mixin(VueHeadMixin);
app.use(VueTippy);
app.use(VueShowdown, {
    flavor: 'github',
});

app.directive('maska', vMaska);
app.directive('capitalize', capitalizeDirective);
app.directive('suppress', suppressDirective);

interceptorSetup();
setupErrorHandling(app);
setupVueApp();

async function setupVueApp() {
    const market: Market = store.getters['general/getMarket'];

    setupSentry(app, router);
    await setupStatsig();
    await loadLanguageAsync(market.locale);

    app.use(vuetify(market.fullLocale));
    app.mount('#app-container');
}
